import { Injectable } from '@angular/core';
import { AbmConfigService } from './abm-config.service';

export enum LoggingLevel {
    NONE = 'NONE',
    DEBUG = 'DEBUG',
    INFO = 'INFO',
    WARN = 'WARN',
    ERROR = 'ERROR',
}

@Injectable({
    providedIn: 'root'
})
export class AbmLoggerService {
    private static readonly prefix = '%cABM';

    private _level: LoggingLevel = LoggingLevel.NONE;

    constructor(private config: AbmConfigService) {
        this._level = this.config.config.loggingLevel ?? LoggingLevel.WARN;
    }

    public log(message: any, level = LoggingLevel.WARN, ...optionalParams: any[]) {
        if (this.shouldLog(level)) {
            switch (level) {
                case LoggingLevel.ERROR:
                    console.error(AbmLoggerService.prefix, 'color:#FD802E', message, ...optionalParams);
                    break;
                case LoggingLevel.WARN:
                    console.warn(AbmLoggerService.prefix, 'color:#FD802E', message, ...optionalParams);
                    break;
                case LoggingLevel.INFO:
                    console.log(AbmLoggerService.prefix, 'color:#FD802E', message, ...optionalParams);
                    break;
                default:
                    console.log(AbmLoggerService.prefix, 'color:#FD802E', message, ...optionalParams);
            }
        }
    }

    private shouldLog(level: LoggingLevel) {
        if (this._level === LoggingLevel.NONE) {
            return false;
        } else if (this._level === LoggingLevel.ERROR) {
            return level === LoggingLevel.ERROR;
        } else if (this._level === LoggingLevel.WARN) {
            return level === LoggingLevel.ERROR || level === LoggingLevel.WARN;
        } else if (this._level === LoggingLevel.INFO) {
            return level === LoggingLevel.ERROR || level === LoggingLevel.WARN || level === LoggingLevel.INFO;
        } else {
            return true;
        }
    }

    public error(message: any, ...optionalParams: any[]) {
        this.log(message, LoggingLevel.ERROR, ...optionalParams);
    }

    public warn(message: any, ...optionalParams: any[]) {
        this.log(message, LoggingLevel.WARN, ...optionalParams);
    }

    public info(message: any, ...optionalParams: any[]) {
        this.log(message, LoggingLevel.INFO, ...optionalParams);
    }

    public debug(message: any, ...optionalParams: any[]) {
        this.log(message, LoggingLevel.DEBUG, ...optionalParams);
    }
}
